// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"129d4aa3","254":"a8c93fcc","503":"bffae533","661":"349c0610","736":"4318f7b9","835":"f78adc65","854":"4b3a5e78"}[chunkId] + ".chunk.js";
};